import { createStyles, makeStyles, Theme } from '@material-ui/core'

export const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            display: 'flex',
            alignItems: 'center',
            marginRight: '1rem'
        },
        highligted: {
            color: 'blue'
        },
        menu: {
            padding: '0.5rem',
            position: 'absolute',
            zIndex: 10000,
            background: 'white'
        }
    }))